import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ScrollIndicator from './components/ScrollIndicator';
import ScrollToTopRoute from './components/ScrollTopRoute';
import About from './pages/About';
import Contact from './pages/Contact';
import Home1 from './pages/Home1';
import News from './pages/News';
import RegenerativeMedicine from './pages/RegenerativeMedicine'
import PlateletRichPlasmaKits from './pages/PlateletRichPlasmaKits'
import GmpProducts from './pages/gmpProducts'
import TheraSorb from './pages/theraSorb'
import BoneMarrow from './pages/boneMarrow'
import TransplantationMedicine from './pages/transplantationMedicine'
import CordBloodBankingKits from './pages/cordBloodBankingKits'
import TissueCellProcessing from './pages/tissueCellProcessing'
import Downloads from './pages/downloads'
import ClinicalApplications from './pages/clinicalApplications'
import PointofCareApplications from './pages/pointofcareApplications';
import CgmpProducts from './pages/cgmpProducts';
import TurnKeyProject from './pages/turnKeyProject';
import EbmtEvent from './pages/embtEvent';
import Event1 from './pages/event1';
import Event2 from './pages/event2';
import CellGeneTherapy from './pages/CellGeneTherapy'

function App() {
    return (
        <>
            <Router>
                <ScrollToTopRoute />
                <Switch>
                    <Route exact path="/RegenerativeMedicine">
                        <RegenerativeMedicine />
                    </Route>
                    <Route exact path="/PlateletRichPlasmaKits">
                        <PlateletRichPlasmaKits />
                    </Route>
                    <Route exact path="/gmpProducts">
                        <GmpProducts />
                    </Route>
                    <Route exact path="/theraSorb">
                        <TheraSorb />
                    </Route>
                    <Route exact path="/boneMarrow">
                        <BoneMarrow />
                    </Route>
                    <Route exact path="/transplantationMedicine">
                        <TransplantationMedicine />
                    </Route>
                    <Route exact path="/cordBloodBankingKits">
                        <CordBloodBankingKits />
                    </Route>
                    <Route exact path="/tissueCellProcessing">
                        <TissueCellProcessing />
                    </Route>
                    <Route exact path="/clinical-applications">
                        <ClinicalApplications />
                    </Route>
                    <Route exact path="/pointofcare-applications">
                        <PointofCareApplications />
                    </Route>
                    <Route exact path="/cgmp-Products">
                        <CgmpProducts />
                    </Route>
                    <Route exact path="/turnKeyProject">
                        <TurnKeyProject />
                    </Route>
                    <Route exact path="/CellGeneTherapy">
                        <CellGeneTherapy />
                    </Route>
                    <Route exact path="/about">
                        <About />
                    </Route>
                    <Route exact path="/news">
                        <News />
                    </Route>
                    <Route exact path="/downloads">
                        <Downloads />
                    </Route>
                    <Route exact path="/contact">
                        <Contact />
                    </Route>
                    <Route exact path="/ebmt-event">
                        <EbmtEvent />
                    </Route>
                    <Route exact path="/cytocare-event-1">
                        <Event1 />
                    </Route>
                    <Route exact path="/cytocare-event-2">
                        <Event2 />
                    </Route>
                    <Route exact path="/">
                        <Home1 />
                    </Route>
                </Switch>
            </Router>
            <ScrollIndicator />
        </>
    );
}

export default App;
